(() => {
  const formSelector = '[data-testid="klaviyo-form-SLmR36"]';
  const teaserSelector = '[data-testid="TEASER"], [data-testid="teaser"]';
  const klaviyoRootSelector = `${formSelector}, ${teaserSelector}, [data-testid="POPUP"]`;
  const observedRoots = new WeakSet();
  const pendingUpdates = new WeakMap();

  const findWithin = (scope, selector) => {
    const matches = [];
    if (scope instanceof Element && scope.matches(selector)) matches.push(scope);
    scope.querySelectorAll?.(selector).forEach((element) => matches.push(element));
    return matches;
  };

  const setRichText = (row, copy) => {
    const richText = row?.querySelector('.klaviyo-form-richtext');
    if (!richText || richText.textContent.trim() === copy) return;

    const paragraph = document.createElement('p');
    paragraph.textContent = copy;
    richText.replaceChildren(paragraph);
  };

  const setButtonLabel = (button, copy) => {
    if (!button) return;
    button.setAttribute('aria-label', copy);
    if (button.textContent.trim() === copy) return;

    const textElement = Array.from(button.querySelectorAll('span')).find((element) => element.textContent.trim());
    if (textElement) {
      textElement.textContent = copy;
      return;
    }

    const textNode = Array.from(button.childNodes).find(
      (node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()
    );
    if (textNode) textNode.nodeValue = copy;
  };

  const applyPopupCopy = (scope) => {
    findWithin(scope, formSelector).forEach((form) => {
      const rows = form.querySelectorAll('[data-testid="form-row"]');
      setRichText(rows[1], 'A $75 welcome, just for you.');
      setRichText(rows[3], 'Get $75 off your next $2,000+ purchase.');
      setRichText(rows[7], 'By signing up, you agree to receive marketing emails. Unsubscribe anytime.');

      const email = form.querySelector('input[type="email"]');
      if (email) email.placeholder = 'Enter your email';

      setButtonLabel(form.querySelector('.klaviyo-form-button'), 'GET MY $75');
    });

    findWithin(scope, teaserSelector).forEach((teaser) => {
      teaser
        .querySelectorAll('button:not(.klaviyo-close-form)')
        .forEach((button) => setButtonLabel(button, 'Get $75'));
    });
  };

  const scheduleUpdate = (root) => {
    const pending = pendingUpdates.get(root);
    if (pending) window.clearTimeout(pending);

    pendingUpdates.set(root, window.setTimeout(() => {
      pendingUpdates.delete(root);
      applyPopupCopy(root);
    }, 80));
  };

  const observeKlaviyoRoot = (candidate) => {
    const root = candidate.closest?.('[data-testid="POPUP"], [data-testid="TEASER"], [data-testid="teaser"]') || candidate;
    if (!(root instanceof Element) || observedRoots.has(root)) return;

    observedRoots.add(root);
    applyPopupCopy(root);

    const observer = new MutationObserver(() => scheduleUpdate(root));
    observer.observe(root, { childList: true, subtree: true });
  };

  const discoverKlaviyoRoots = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches(klaviyoRootSelector)) observeKlaviyoRoot(node);
    node.querySelectorAll(klaviyoRootSelector).forEach(observeKlaviyoRoot);
  };

  const startDiscovery = () => {
    discoverKlaviyoRoots(document.body);

    const discoveryObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(discoverKlaviyoRoots);
      });
    });

    discoveryObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => discoveryObserver.disconnect(), 30000);
  };

  window.addEventListener('klaviyoForms', (event) => {
    if (event.detail?.type !== 'open') return;
    window.requestAnimationFrame(() => discoverKlaviyoRoots(document.body));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startDiscovery, { once: true });
  } else {
    startDiscovery();
  }
})();
